const initialState = {
  tagsList: [],
};

export const cropTagsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "crop-tags")
    return action.execute(state);
  return state;
};
